import { render, staticRenderFns } from "./SaveCancel.vue?vue&type=template&id=7620dda8&scoped=true&"
import script from "./SaveCancel.vue?vue&type=script&lang=js&"
export * from "./SaveCancel.vue?vue&type=script&lang=js&"
import style0 from "./SaveCancel.vue?vue&type=style&index=0&id=7620dda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620dda8",
  null
  
)

export default component.exports